import { Link, useParams } from "react-router-dom";
import { ManaText } from "@/components/common/ManaSymbol";
import { useQuery } from "@tanstack/react-query";
import { api, assetUrl } from "@/lib/api";
import { RulingsPanel } from "@/components/rules/RulingsPanel";

function CardThumbs({ cards, testid }) {
  if (!cards.length) return <p className="text-sm text-slate-500">None yet.</p>;
  return (
    <ul className="grid grid-cols-3 gap-3 sm:grid-cols-4" data-testid={testid}>
      {cards.map((c) => <li key={c.id}><Link to={`/cards/${c.id}`} className="block" data-testid={`${testid}-${c.id}`}>
        {c.image_url ? <img src={assetUrl(c.image_url)} alt={c.name} className="rounded-md border border-[#2A3447]" /> : <span className="block rounded-md border border-[#2A3447] p-3 text-xs text-slate-300">{c.name}</span>}
      </Link></li>)}
    </ul>
  );
}

export default function MechanicDetail() {
  const { mechanicId } = useParams();
  const { data: m, error } = useQuery({ queryKey: ["mechanic", mechanicId], retry: false, queryFn: () => api.get(`/mechanics/${mechanicId}`).then((r) => r.data) });
  if (error) return <div className="container-x py-16 text-slate-400" data-testid="mechanic-not-found">Mechanic not found.</div>;
  if (!m) return <div className="container-x py-16 text-slate-500">Loading…</div>;
  return (
    <div className="container-x grid gap-8 py-12 lg:grid-cols-[1fr_420px]" data-testid="mechanic-detail-page">
      <div className="space-y-6">
        <div>
          <p className="eyebrow">{m.kind?.replace("_", " ")} · {m.scope === "platform" ? "platform-wide" : m.community?.name}</p>
          <h1 className="font-display text-4xl text-amber-100" data-testid="mechanic-name">{m.name}</h1>
          <p className="mt-1 font-mono text-xs text-slate-500">v{m.version} · by @{m.creator?.username} · <span data-testid="mechanic-status">{m.status.replace("_", " ")}</span>
            {m.revision_pending && <span className="text-copper-300"> · revision under review</span>}</p>
        </div>
        <div className="panel p-5">
          {m.reminder_text && <p className="mb-3 italic text-slate-400" data-testid="mechanic-reminder">({m.reminder_text})</p>}
          <p className="whitespace-pre-line text-slate-200" data-testid="mechanic-definition">{m.definition}</p>
          {m.keywords?.length > 0 && <p className="mt-3 font-mono text-xs text-slate-500">Keywords: {m.keywords.join(", ")}</p>}
        </div>
        {m.examples?.length > 0 && <div className="panel p-5"><p className="eyebrow mb-2">Examples</p>
          <ul className="space-y-2 text-sm text-slate-300">{m.examples.map((e, i) => <li key={i}>{e.card ? <Link to={`/cards/${e.card.id}`} className="text-amber-300">{e.card.name}</Link> : null} <ManaText text={e.text} /></li>)}</ul></div>}
        <div><p className="eyebrow mb-3">Cards using this mechanic</p><CardThumbs cards={m.associated_cards} testid="mechanic-associated-cards" /></div>
      </div>
      <RulingsPanel targetType="mechanic" targetId={m.mechanic_id} ownerId={m.creator?.user_id} />
    </div>
  );
}
